import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { CustomPropTypes } from '@beef/react';
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);

/**
 * You should not use this component head on, use Description instead
 *
 * Renders entire rightSide content block
 * of Desktop version of Descriptions component
 */
export default function DescriptionContent(_ref) {
  var Wrapper = _ref.Wrapper,
    title = _ref.title,
    children = _ref.children,
    TitleTag = _ref.TitleTag;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-t-id": "components-DescriptionContent"
  }, /*#__PURE__*/React.createElement(TitleTag, {
    className: cx('heading'),
    "data-t-id": "components-DescriptionContent"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cx('desktopContentBody')
  }, children));
}
DescriptionContent.propTypes = process.env.NODE_ENV !== "production" ? {
  Wrapper: CustomPropTypes.component,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  TitleTag: PropTypes.string
} : {};
DescriptionContent.defaultProps = {
  Wrapper: React.Fragment
};